import { analyserMarkdown, type Segment } from '../../onboarding/markdown'

/**
 * Rendu d'un markdown de contrat, SANS `dangerouslySetInnerHTML` : l'analyseur
 * produit un arbre, React échappe chaque texte. Une balise HTML collée dans un
 * contrat s'affiche en clair, elle n'est jamais interprétée.
 */
const Inline = ({ segments }: { segments: Segment[] }) => (
  <>
    {segments.map((s, i) => (s.gras ? <strong key={i}>{s.texte}</strong> : <span key={i}>{s.texte}</span>))}
  </>
)

export function MarkdownRendu({ source }: { source: string }) {
  const blocs = analyserMarkdown(source)
  if (blocs.length === 0) return <p className="dos-note">Texte vide.</p>
  return (
    <div className="md-rendu">
      {blocs.map((b, i) => {
        if (b.type === 'titre') {
          const T = (`h${b.niveau}`) as 'h1' | 'h2' | 'h3'
          return <T key={i}><Inline segments={b.segments} /></T>
        }
        if (b.type === 'liste') {
          const items = b.elements.map((el, j) => <li key={j}><Inline segments={el} /></li>)
          return b.ordonnee ? <ol key={i}>{items}</ol> : <ul key={i}>{items}</ul>
        }
        return <p key={i}><Inline segments={b.segments} /></p>
      })}
    </div>
  )
}
